import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Header({ breadcrumbs = [] }) {
  const { logout } = useAuth();

  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="header-brand">
          <img src="/ms-logo.jpg" alt="Math&amp;Sport" className="brand-logo" />
          <span className="brand-name">M<span className="brand-amp">&amp;</span>S Portal</span>
        </div>

        {breadcrumbs.length > 0 && (
          <nav className="breadcrumbs" aria-label="Percorso">
            {breadcrumbs.map((crumb, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="breadcrumb-sep">›</span>}
                {crumb.onClick ? (
                  <button className="breadcrumb-link" onClick={crumb.onClick}>
                    {crumb.label}
                  </button>
                ) : (
                  <span className="breadcrumb-current">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        <button className="btn btn-ghost btn-sm header-logout" onClick={logout}>
          Esci
        </button>
      </div>
    </header>
  );
}
